import React, {useEffect, useState} from 'react';
import {Col, Form, Row} from 'react-bootstrap';

import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import {boldTextStyles, regularErrorStyle, regularTextStyles} from "../Style";
import NavigateCarInsurance from "./NavigateCarInsurance";
import DatePicker from "react-datepicker";
import {FaCalendarAlt} from "react-icons/fa";
import DirectDebitTerms from "./DirectDebitTerms";
import {useSearchParams} from "react-router-dom";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

const DirectDebit = (props) => {
  // var widget = null;
  const [declarationPopupShow, setDeclarationPopupShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [authorised, setAuthorised] = useState(false);
  const [searchParams] = useSearchParams();
  const {executeRecaptcha} = useGoogleReCaptcha();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const [verificationFailedStep, setVerificationFailedStep] = useState('');
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
      ? 'carAutosureEvent'
      : window.location.href.includes('quashed')
          ? 'carQuashedEvent'
          : window.location.href.includes('better')
              ? 'carBetterEvent'
              : window.location.href.includes('simplify')
                  ? 'carSimplifyEvent'
                  : '';

  useEffect((e) => {
    if (verificationFailedStep === 'proceedWithPayment') {
      proceedWithPayment(e).then(r => console.log("proceedWithPayment"));
    }
  }, [props.inputValues.isRecaptchaV2Verified]);

  useEffect(() => {

    // if(props.inputValues.paymentStartDate === '') {
    //     var date_new = new Date();
    //    props.handleChangeValue('paymentStartDate',new Intl.DateTimeFormat('en-GB').format(date_new));
    // }

    window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Page View',
        'categoryDetails': 'Direct Debit - Bank Transfer',
        'virtualUrl': `${baseUrl}/vehicle/step5`,
        'pageTitle': 'Payment',
      });

    window.scrollTo(0, 0)
    // Track the 'page loaded' event

  }, [])

  const findFormErrors = () => {
    const newErrors = {}
    if (!props.inputValues.accountName || props.inputValues.accountName === '') {
      newErrors.accountName = "Please enter bank account name";
    }
    if (!props.inputValues.accountNumber || props.inputValues.accountNumber === '') {
      newErrors.accountNumber = "Please enter bank account number";
    }
    if (!props.inputValues.accountAuthorizer || props.inputValues.accountAuthorizer === '') {
      newErrors.accountAuthorizer = "Please enter authoriser name";
    }
    if (!authorised) {
      newErrors.authorised = "Please check the authorization";
    }
    return newErrors;
  }

  const proceedWithPayment = async (event) => {
    // console.log(props.inputValues);
    // console.log("props", props);
    setErrors({});
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      // Scroll to the first error
      const firstErrorKey = Object.keys(newErrors)[0];
      const errorElement = document.getElementsByName(firstErrorKey)[0];
      if (errorElement) {
        errorElement.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
      setErrors(newErrors);
    } else if (!props.inputValues.directDebitTermAccepted) {
      setDeclarationPopupShow(true);
    } else {
      // event.preventDefault();
      setIsButtonDisabled(true);
      let search = window.location.search;
      let params = new URLSearchParams(search);
      let renewalId = encodeURIComponent(params.get('id'));
      let initials = props.inputValues.driverList.driver1.firstName[0] + props.inputValues.driverList.driver1.lastName[0];

      let jwt = Cookies.get('jwt-token');
      let fullName = props.inputValues.firstName + " " + props.inputValues.lastName
      const instalmentDebitDay = props.inputValues.paymentStartDate
        ? new Date(props.inputValues.paymentStartDate).getDate()  // Use day from paymentStartDate if available
        : props.inputValues.policyStartDate
          ? new Date(props.inputValues.policyStartDate).getDate()  // Use day from policyStartDate if available
          : new Date().getDate();  // Otherwise use the current date

      const driverArray = Object.keys(props.inputValues.driverList).map(key => props.inputValues.driverList[key]);
      const additionalDriverArray = [];

      driverArray.map((driver, idx) => {
        if (idx !== 0 && driver.firstName !== '') {
          let incidentList = [];
          for (let i = 1; i < 5; i++) {
            if (driver.incidentList["incidents" + i].claimCode !== '') {
              incidentList.push(driver.incidentList["incidents" + i]);
            }
          }
          let initialsAdditionalDriver = driver.firstName[0] + driver.lastName[0];
          let additionalDriver = {
            "dateOfBirth": driver.dateOfBirth.split("/").reverse().join("-"),
            "claimHistory": incidentList,
            "givenName": driver.firstName,
            "initials": initialsAdditionalDriver,
            "surname": driver.lastName,
          };
          additionalDriverArray.push(additionalDriver);
        }
      })

      const policyHolderArray = Object.keys(props.inputValues.policyHolderList).map(key => props.inputValues.policyHolderList[key]);
      const additionalPolicyHolderArray = [];
      policyHolderArray.map((policyHolder, idx) => {
        if (idx !== 0 && policyHolder.firstName !== '') {
          let additionalPolicyHolder = {
            "contactDetails": {
              "emailAddress": policyHolder.email,
              "landlineNum": policyHolder.phone,
              "mobileNum": policyHolder.mobileCode.concat(policyHolder.mobile)
            },
            "dob": policyHolder.dateOfBirth.split("/").reverse().join("-"),
            "givenName": policyHolder.firstName,
            "surname": policyHolder.lastName,
            "title": policyHolder.title
          };
          additionalPolicyHolderArray.push(additionalPolicyHolder);
        }
      })
      if (!executeRecaptcha) {
        console.log('reCAPTCHA is not ready');
        return;
      }
      let token = await executeRecaptcha('submit');
      if (props.inputValues.isRecaptchaV2Verified) {
        token = "AUTHENTICATED_V2"
      }
      fetch(url + '/vero/quote/bind', {

        method: "POST",
        mode: "cors",
        headers: new Headers({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${jwt}`
        }),
        body: JSON.stringify(
          {
            "attributes": {
              "bindPolicyParties": {
                "additionalPolicyHolders": additionalPolicyHolderArray,
                "interestedParties": props.inputValues.financeCompany
                  ? [props.inputValues.financeCompany]
                  : null,
                "primaryPolicyHolder": {
                  "individualPolicyHolder": {
                    "contactDetails": {
                      "emailAddress": props.inputValues.policyHolderList.policyHolder1.email,
                      "landlineNum": props.inputValues.policyHolderList.policyHolder1.phone,
                      "mobileNum": props.inputValues.policyHolderList.policyHolder1.mobileCode.concat(props.inputValues.policyHolderList.policyHolder1.mobile)
                    },
                    "dob": props.inputValues.policyHolderList.policyHolder1.dateOfBirth.split("/").reverse().join("-"),
                    "givenName": props.inputValues.policyHolderList.policyHolder1.firstName,
                    "surname": props.inputValues.policyHolderList.policyHolder1.lastName,
                    "title": props.inputValues.policyHolderList.policyHolder1.title
                  }
                }
              },
              "bindVehicleDetails": {
                "carRegistration": props.inputValues.regNumber,
                "additionalDrivers": additionalDriverArray,
                "mainDriver": {
                  "claimHistory": [],
                  "dateOfBirth": props.inputValues.driverList.driver1.dateOfBirth.split("/").reverse().join("-"),
                  "givenName": props.inputValues.driverList.driver1.firstName,
                  "initials": initials,
                  "surname": props.inputValues.driverList.driver1.lastName,
                }
              },
              "endConsentDetails": {
                "emailAddress": props.inputValues.policyHolderList.policyHolder1.email,
                "endConsentIndicator": true,
                "mobileNumber": props.inputValues.policyHolderList.policyHolder1.mobileCode.concat(props.inputValues.policyHolderList.policyHolder1.mobile)
              },
              "paymentContextDetails": {
                "bankPaymentDetails": {
                  "authorizerName": props.inputValues.accountAuthorizer,
                  "bankAccountName": props.inputValues.accountName,
                  "bankAccountNumber": props.inputValues.accountNumber
                },
                "instalmentDebitDay": instalmentDebitDay
              },
              "policyHistory": {
                "lastModifiedDatetime": JSON.parse(props.inputValues.responseJson).data.attributes.policyDetails.policyHistory.lastModifiedDatetime,
                "lastModifiedUserId": JSON.parse(props.inputValues.responseJson).data.attributes.policyDetails.policyHistory.lastModifiedUserId
              },
              "postalAddress": {
                "addressId": props.inputValues.postalAddress.addressId,
                "addressInBrokenDownForm": {
                  "streetName": props.inputValues.postalAddress.streetName,
                  "streetNumber": props.inputValues.postalAddress.streetNumber,
                  "streetType": props.inputValues.postalAddress.streetType,
                  "unitType" : props.inputValues.postalAddress.unitType,
                  "unitNumber" : props.inputValues.postalAddress.unitNumber,
                  "buildingName" :props.inputValues.postalAddress.buildingName,
                  "levelNumber":props.inputValues.postalAddress.levelNumber,
                  "levelType" : props.inputValues.postalAddress.levelType,
                  "streetSuffixCode" : props.inputValues.postalAddress.streetSuffixCode,

                },
                "addressInFreeForm": {
                  "addressLine1": props.inputValues.postalAddress.addressLine1,
                  "addressLine2": props.inputValues.postalAddress.addressLine2
                },
                "postcode": props.inputValues.postalAddress.postcode,
                "signature": props.inputValues.postalAddress.signature,
                "suburb": props.inputValues.postalAddress.suburb
              },
              "questions": [
                {
                  "answer": "N",
                  "code": "003"
                },
                {
                  "answer": "N",
                  "code": "004"
                }
              ],
              "quoteDetails": {
                "insuredDetails": {
                  "customerDob": props.inputValues.policyHolderList.policyHolder1.dateOfBirth.split("/").reverse().join("-"),
                  "customerPostcode": props.inputValues.riskPostcode
                },
                "quoteNumber": JSON.parse(props.inputValues.responseJson).data.attributes.policyDetails.quoteNum
              }
            },
            "type": "string",
            "id": props.inputValues.id,
            "recaptchaResponse": token
          }
        )
      })
        .then((response) => {
          if (response.status === 428) {
            // Show fallback captcha for 428 status
            console.log('Primary reCAPTCHA failed for proceedWithPayment, showing fallback captcha');
            //setIsSubmitting(false);
            props.handleChangeValue("showRecaptchaPopup", true);
            setVerificationFailedStep("proceedWithPayment");
            return;
          }
          if (!response.ok) {
            props.paymentFailurePage();
          } else {
            response.json().then((json) => {
              props.handleChangeValue("policyNumber", json.policyNumber);
              props.nextStep();
            });
          }
        })
        .catch((error) => {
          console.log('Error:', error);
          props.paymentFailurePage();
        })
    }
  }

  const steps = [{name: 'Step 1', status: 'complete', desc: 'Car'}, {
    name: 'Step 2',
    status: 'complete',
    desc: 'Driver'
  }, {name: 'Step 3', status: 'complete', desc: 'Quote'}, {
    name: 'Step 4',
    status: 'complete',
    desc: 'Policyholder'
  }, {name: 'Step 5', status: 'current', desc: 'Payment'},];

  const handleApplicantTypeUpdate = (event) => {
    props.handleChangeValue('applicantType', event.target.name);
  }
  const updateAuthorised = (event) => {
    setAuthorised(event.target.checked);
  }
  const updateAgreeToTerms = (event) => {
    props.handleChangeValue('agreeToDirectTerms', event.target.checked);
  }
  return (
    <>
      <br/><br/>
      <Row className="justify-content-center">
        <NavigateCarInsurance steps={steps}/>
      </Row>
      <div className="lg-car-padding sm-car-padding" style={{display: 'flex', justifyContent: "center"}}>
        <Form>
          <div style={{paddingBottom: "10px"}}>
            <div style={{paddingBottom: "10px"}}><span
              style={regularTextStyles}>Your premium details are:</span></div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '310px',
                // boxShadow: '-1px 1px 5px 6px rgba(0,0,0,0.06)',
                border: '1px solid #D1D5DB',
              }}>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "50px"
              }}>
                <div
                  id="policyNumberTitle"
                  data-testid="policy-title-payment-frequency"
                  style={{
                    background: 'white',
                    textAlign: "start", paddingLeft: "24px", width: "100%",
                    color: '#6B7280',
                  }}
                >Payment Frequency
                </div>
                <div id="policyNumberVal"
                     data-testid="policy-value-payment-frequency"
                     style={{
                       color: "black",
                       textAlign: "start",
                       paddingLeft: "24px",
                       width: "100%"
                     }}
                ><span style={boldTextStyles}
                >{props.inputValues.paymentFrequency}</span>
                </div>
              </div>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "50px"
              }}>
                <div
                  id="policyNumberTitle"
                  data-testid="policy-title-amount"
                  style={{
                    background: 'white',
                    textAlign: "start", paddingLeft: "24px", width: "100%",
                    color: '#6B7280',
                  }}
                >Amount
                </div>
                <div id="policyNumberVal"
                    data-testid="policy-value-amount"
                     style={{
                       color: "black",
                       textAlign: "start",
                       paddingLeft: "24px",
                       width: "100%"
                     }}
                ><span style={boldTextStyles}>${props.inputValues.premium}</span>
                </div>
              </div>
            </div>
          </div>
          {props.inputValues.paymentFrequency === 'MONTHLY' &&
            <div style={{paddingBottom: "34px"}}>
              <span style={regularTextStyles}> Once your instalment payment has been set up, your payments will be taken on the same day each month, or as close to that day as possible. However, you will be insured from your policy start date. </span>
            </div>
          }
          {props.inputValues.paymentFrequency === 'FORTNIGHTLY' &&
            <div style={{paddingBottom: "34px"}}>
              <span style={regularTextStyles}> Once your instalment payment has been set up, your payments will be taken on the same day each fortnight, or as close to that day as possible. However, you will be insured from your policy start date. </span>
            </div>
          }
          <div style={{display: "flex", justifyContent: "space-between", paddingBottom: "50px"}}
               className="column-on-mobile">
            <Form.Group md="3" as={Col} controlId="formAccountName" className="form-group">
              <Form.Label style={regularTextStyles}>Bank account name</Form.Label>
              <input
                type="text"
                className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                style={{
                  border: '1px #E5E7EB solid',
                  boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                  borderRadius: 6,
                  outline: 'none',
                  fontSize: '1rem', //16px
                  fontFamily: 'Lato',
                  fontWeight: '400',
                  lineHeight: 'inherit',
                  width: '100%',
                  maxWidth: '300px',
                  height: '40px',
                  marginRight: '10px',
                  background: 'transparent',
                }}
                defaultValue={(props.inputValues.accountName)}
                name="accountName"
                required
                onChange={props.handleChange}
              />
              {errors.accountName && (
                <div style={regularErrorStyle}>{errors.accountName}</div>
              )}
            </Form.Group><Col md="1"/>
            <Form.Group as={Col} md="3" controlId="formAccountNumber" className="form-group">
              <Form.Label className="label" style={regularTextStyles}>Bank account number</Form.Label>
              <input
                type="text"
                className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                style={{
                  border: '1px #E5E7EB solid',
                  boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                  borderRadius: 6,
                  outline: 'none',
                  fontSize: '1rem', //16px
                  fontFamily: 'Lato',
                  fontWeight: '400',
                  lineHeight: 'inherit',
                  width: '100%',
                  maxWidth: '300px',
                  height: '40px',
                  marginRight: '10px',
                  background: 'transparent',
                }}
                placeholder="00-0000-0000000-00"
                defaultValue={props.inputValues.accountNumber}
                name="accountNumber"
                required
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, '');
                  // Format the number according to the bank account pattern
                  if (value.length > 0) {
                    let formatted = '';
                    if (value.length >= 2) {
                      formatted += value.substring(0, 2) + '-';
                    } else {
                      formatted += value;
                    }
                    if (value.length > 2) {
                      if (value.length >= 6) {
                        formatted += value.substring(2, 6) + '-';
                      } else {
                        formatted += value.substring(2);
                      }
                    }
                    if (value.length > 6) {
                      if (value.length >= 13) {
                        formatted += value.substring(6, 13) + '-';
                      } else {
                        formatted += value.substring(6);
                      }
                    }
                    if (value.length > 13) {
                      formatted += value.substring(13, 15);
                    }
                    value = formatted;
                  }
                  if (value.length > 19) {
                    value = value.substring(0, 19);
                  }
                  e.target.value = value;
                  props.handleChange(e);
                }}
              />
              {errors.accountNumber && (
                <div style={regularErrorStyle}>{errors.accountNumber}</div>
              )}
            </Form.Group><Col md="1"/>
            <Form.Group as={Col} md="3" controlId="validationCustom02" className="form-group">
              <Form.Label style={regularTextStyles}>Name of authoriser</Form.Label>
              <input
                className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                style={{
                  border: '1px #E5E7EB solid',
                  boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                  borderRadius: 6,
                  outline: 'none',
                  fontSize: '1rem', //16px
                  fontFamily: 'Lato',
                  fontWeight: '400',
                  lineHeight: 'inherit',
                  width: '100%',
                  maxWidth: '300px',
                  height: '40px',
                  marginRight: '10px',
                  background: 'transparent',
                }}
                required
                type="text"
                name="accountAuthorizer"
                defaultValue={props.inputValues.accountAuthorizer}
                onChange={props.handleChange}

              />
              {errors.accountAuthorizer && (
                <div style={regularErrorStyle}>{errors.accountAuthorizer}</div>
              )}
            </Form.Group><Col md="1"/>
          </div>
          <div style={{paddingBottom: "10px"}}>
            <div style={boldTextStyles}>
              <label>
              <input type="checkbox" className="custom-radio" checked={authorised}
                     onClick={updateAuthorised}/>
                &nbsp;&nbsp;&nbsp;I am authorised to operate this bank account independently.</label>
            </div>
            {errors.authorised && (
              <div style={regularErrorStyle}>{errors.authorised}</div>
            )}
          </div>
          {/*{ authorised && <div style={{display: "flex", justifyContent: "space-between"}} className="column-on-mobile">*/}
          {/*    <Form.Group as={Col} md="3" controlId="validationCustom02" className="form-group">*/}
          {/*        <Form.Label style={regularTextStyles}>Name of Authorizer</Form.Label>*/}
          {/*        <input*/}
          {/*            className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"*/}
          {/*            style={{*/}
          {/*                border: '1px #E5E7EB solid',*/}
          {/*                boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',*/}
          {/*                borderRadius: 6,*/}
          {/*                outline: 'none',*/}
          {/*                fontSize: '1rem', //16px*/}
          {/*                fontFamily: 'Lato',*/}
          {/*                fontWeight: '400',*/}
          {/*                lineHeight: 'inherit',*/}
          {/*                width: '100%',*/}
          {/*                maxWidth: '300px',*/}
          {/*                height: '40px',*/}
          {/*                marginRight: '10px',*/}
          {/*                background: 'transparent',*/}
          {/*            }}*/}
          {/*            required*/}
          {/*            type="text"*/}
          {/*            name="accountAuthorizer"*/}
          {/*            defaultValue={props.inputValues.accountAuthorizer}*/}
          {/*            onChange={props.handleChange}*/}

          {/*        />*/}
          {/*        <Form.Control.Feedback type="invalid">*/}
          {/*            {errors.accountAuthorizer}*/}
          {/*        </Form.Control.Feedback>*/}
          {/*    </Form.Group><Col md="1"/>*/}
          {/*</div> }*/}

          <div>
            <div style={{paddingTop: "50px"}}>
              <span style={regularTextStyles}> Payment Start Date</span>
              <div style={{width: '100%', maxWidth: '300px', marginRight: '10px', position: 'relative'}}>
                <DatePicker
                  selected={props.inputValues.paymentStartDate ? props.inputValues.paymentStartDate : props.inputValues.policyStartDate}
                  onChange={(date) => props.handleChangeValue('paymentStartDate', date)}
                  dateFormat="dd/MM/yyyy"
                  className="custom-datepicker"
                  placeholderText="DD/MM/YYYY"
                  minDate={props.inputValues.policyStartDate ? props.inputValues.policyStartDate : null}
                  maxDate={props.inputValues.policyStartDate ? new Date(props.inputValues.policyStartDate.getTime() + 14 * 24 * 60 * 60 * 1000) : null}
                />
                <FaCalendarAlt style={{
                  position: 'absolute',
                  right: '20px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer'
                }}/>
              </div>

            </div>
          </div>
          <div style={{display: "flex", justifyContent: "space-between"}} className="column-on-mobile">

            <Col md="1"/>
            <Col md="1"/>
          </div>
          <br/>

          <br/>
          <p>&nbsp;</p>
          <p
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: "center",
              paddingTop: '20px'
            }}>
            <button
              className="btn rounded-md px-4 py-2.5 text-sm font-weight-bold text-gray-900 shadow-sm"
              onClick={() => props.prevStep()}
              style={{
                color: '#1851A3',
                paddingLeft: 25,
                paddingRight: 25,
                paddingTop: 13,
                paddingBottom: 13,
                background: 'white',
                border: '1px #1851A3 solid',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
                wordWrap: 'break-word',
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: 6,
                width: "100%",
                maxWidth: "200px"
              }}>
              Back
            </button>
            <button className="float-end" type="button"
                    onClick={proceedWithPayment}
                    style={{
                      color: 'white',
                      paddingLeft: 25,
                      paddingRight: 25,
                      paddingTop: 13,
                      paddingBottom: 13,
                      width: "100%",
                      maxWidth: "200px",
                      background: '#1851A3',
                      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                      borderRadius: 6,
                      overflow: 'hidden',
                      border: '1px white solid',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'inline-flex',
                      cursor: isButtonDisabled ? 'progress' : 'pointer',
                      opacity: isButtonDisabled ? 0.6 : 1,
                    }}
                    disabled={isButtonDisabled}
            >
              Next
            </button>
          </p>
          <br/><br/><br/><br/><br/><br/>
        </Form></div>
      <DirectDebitTerms
        parentDeclarationPopupShow={declarationPopupShow}
        setParentDeclarationPopupShow={setDeclarationPopupShow}
        handleChangeValue={props.handleChangeValue}
        proceedWithPayment={proceedWithPayment}
        // parentNextStep={props.nextStep}
      />
    </>
  );

}

export default DirectDebit;
